import { CSSProperties } from "react";
import { MinusOutlineIcon, PlusOutlineIcon } from "../Icons";
import classes from "./QuantityChange.module.css";

interface Props {
	className?: string;
	style?: CSSProperties;

	quantity?: number;
	disabled?: boolean;

	maxQuantity?: number;
	minQuantity?: number;

	addQuantity?: () => void;
	removeQuantity?: () => void;

	price?: number;
}

const QuantityChange = ({
	className,
	style,

	quantity = 1,
	disabled = false,

	maxQuantity,
	minQuantity = 1,

	addQuantity = () => {},
	removeQuantity = () => {},
	price = 0,
}: Props) => {
	const classNames = [classes.QuantityChange, className];

	return (
		<div className={classNames.join(" ")} style={style}>
			<button
				className={`${classes.button} ${classes.decrease}`}
				onClick={removeQuantity}
				disabled={ (quantity <= 1 )  || disabled}>
				<MinusOutlineIcon className={classes.icon} />
			</button>

			<p className={classes.quantity}>{quantity}</p>

			<button
				className={`${classes.button} ${classes.increase}`}
				onClick={addQuantity}
				disabled={
					disabled || (!!maxQuantity && quantity >= maxQuantity ) ||  price  < 10
				}>
				<PlusOutlineIcon className={classes.icon} />
			</button>
		</div>
	);
};

export default QuantityChange;
